import { Loader, Center } from '@mantine/core';
import { useEffect, type ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import type { Permission } from '../types';

import { useAuth } from './AuthProvider';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission?: Permission;
}

export default function ProtectedRoute({ children, requiredPermission }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuth();
  const navigate = useNavigate();

  const hasPermission = requiredPermission ? user?.permissions?.includes(requiredPermission) : true;

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate('/login', { replace: true });
    } else if (!isLoading && isAuthenticated && !hasPermission) {
      navigate('/', { replace: true });
    }
  }, [isLoading, isAuthenticated, hasPermission, navigate]);

  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader size="xl" />
      </Center>
    );
  }

  if (!isAuthenticated || !user || !hasPermission) {
    return null;
  }
  return <>{children}</>;
}
